export default __webpack_public_path__ + "media/images/landing-5-550x420-ede9f54b677e419b2d48a4f83600e74d.jpg";